import { ThumbRatingContainer } from '@/reports/ThumbRating/ThumbRatingContainer';
import { RestoreAllDataButton } from '@/reports/ThumbRating/feedbackButtons';
import { ReportSection, WarningFooter } from '@/reports/index';
import { StaticMap } from '@/reports/maps/StaticMap/StaticMap';
import { commonTypes } from '@/reports/types';
import { Text } from '@/theme/index';
import { pluralizeString } from '@/utils/pluralizeString';
import { AddressCard } from './AddressCard';

export interface AddressHistoryProps {
  addresses: commonTypes.Addresses;
  personName: string;
  addressCount: number;
  permalink: string;
  showCityAndStateAddress?: boolean;
}

export const AddressHistory = ({
  addressCount,
  addresses = [],
  personName = '',
  permalink,
  showCityAndStateAddress = false,
}: AddressHistoryProps) => {
  return (
    <ReportSection
      title="Possible Address History"
      hasContent={addressCount > 0}
      sectionDescription={`Public records indicate ${
        personName.split(' ')[0]
      } may have resided, worked and/or owned property at the following addresses.`}
      sectionId="address-history-section"
      personName={personName}
      FooterComponent={<WarningFooter />}
    >
      <Text>
        {addressCount} {pluralizeString('address', addressCount)} identified
      </Text>
      {!showCityAndStateAddress && (
        <StaticMap width={768} height={350} withMarker locations={addresses} />
      )}
      {addresses.map((address, index) => (
        <ThumbRatingContainer
          key={index}
          component={AddressCard}
          dataPropKey="address"
          item={address}
          permalink={permalink}
          cardProps={{ ownerName: personName }}
          showCityAndStateAddress={showCityAndStateAddress}
        />
      ))}
      <RestoreAllDataButton items={addresses} permalink={permalink} />
    </ReportSection>
  );
};
